<template>
    <div :class="preCls + 'content-box'" style="background: rgb(242, 242, 246)">
        <div class="header">
            <header-left class="header-left"></header-left>
            <header-right class="header-right"></header-right>
        </div>
        <EcMain class="EcMain"></EcMain>
        <EcFooter class="EcFooter"></EcFooter>
    </div>
</template>

<script>
import HeaderLeft from './header-left'
import HeaderRight from './header-right'
import EcMain from './main'
import EcFooter from './footer'
import PieMixin from '@/views/common/m-chart-pie'
import LineMixin from '@/views/common/m-chart-line'

export default {
    name: '',
    mixins: [PieMixin, LineMixin],
    data() {
        return {
            isActive: true,
        }
    },
    components: {
        HeaderLeft,
        HeaderRight,
        EcMain,
        EcFooter,
    },
}
</script>

<style lang="less" scoped>
.header {
    display: flex;
    height: 400px;
    &-left {
        width: 50%;
        background: rgb(255, 255, 255);
        margin-right: 14px;
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
    }
    &-right {
        padding-top: 10px;
        width: 50%;
        background: rgb(255, 255, 255);
        box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        margin-left: 14px;
    }
}

.EcMain {
    height: 400px;
    background: rgb(255, 255, 255);
    margin-top: 25px;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
}
.EcFooter {
    margin-top: 25px;
}
</style>
